import { BaseIcon, type BaseIconProps } from '@fountain/ripple/icon';
import React, { forwardRef } from 'react';

// Source: images/ScoreApplicantIcon.tsx (Posthire Profile drawing).
export const ScoreDrawingIcon = forwardRef<SVGSVGElement, BaseIconProps>(
  function ScoreDrawingIcon(props, ref) {
    return (
      <BaseIcon
        ref={ref}
        viewBox="0 0 18 18"
        fill="currentColor"
        stroke="none"
        {...props}
      >
        <path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 10C6.9 10 6 9.1 6 8C6 7.8 6 7.7 6.1 7.5L3.6 5L5 3.6L7.5 6.1C7.7 6 7.8 6 8 6C9.1 6 10 6.9 10 8C10 9.1 9.1 10 8 10Z" />
      </BaseIcon>
    );
  },
);
